/*global _ */
import ReValidate from './../re-validation'
import props from './../../../../props/inputs'

import {Settings, TIMEZONE, locale} from '../../../../lib/dates'
Settings.defaultLocale = locale || 'en-us'

import DatetimePicker from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'


export default {
  name: 're-date-picker',
  components: {
    DatetimePicker,
    [ReValidate.name]: ReValidate
  },
  props: {
    ...props,
    label: {
      type: String,
      default: "Select Date"
    },
    timeZone: {
      type: String,
      default: TIMEZONE
    }
  },
  data() {
    return {
      selectedDate: null
    }
  },

  created() {
    if (this.value && !_.isObject(this.value)) {
      this.selectedDate = ('' + this.value).trim()
    }
  },

  watch: {
    value(newValue) {
      if (_.isObject(newValue)) {
        this.selectedDate = null
      } else {
        this.selectedDate = ('' + newValue).trim()
      }
    },
    selectedDate(newValue) {
      if (_.isObject(newValue)) {
        newValue = null
      } else {
        newValue = ('' + newValue).trim()
      }
      this.$emit('input', newValue)
    }
  },

  computed: {
    inputId() {
      return !_.isEmpty(this.id) ? this.id : 'date_'+Math.floor(100 * Math.random())
    }
  }
}
